import {Component, OnInit, Input, ViewEncapsulation} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {TasksModel} from '../../../tasks/models/tasks.model';
import {TasksService} from '../../../tasks/tasks.service';

@Component({
    selector: 'app-journey-list-template-html',
    templateUrl: './list-template-html.component.html',
    styleUrls: ['./list-template-html.component.scss'],
    // encapsulation: ViewEncapsulation.None
})
export class LearningJourneyListTemplateHtmlComponent implements OnInit {
    @Input() title = null;
    @Input() html;
    @Input() task: TasksModel = null;
    @Input() disabled = false;
    @Input() for_manager = false;
    @Input() for_coach = false;

    constructor(
        public sanitizer: DomSanitizer,
        private tasksService: TasksService
    ) {
    }

    ngOnInit() {
    }

    changeStatus(task: TasksModel) {
        this.tasksService.updateTaskStatus(task);
    }
}
